import React, { PureComponent} from 'react';
import PropTypes from 'prop-types';
import {createContainer} from '@dbk-legacy/muster/react';
import Settings from '../../../data/settings';
import SimpleDate from '../../../components/common/date';

const propTypes = {
  dataInfo: PropTypes.array.isRequired,
  key: PropTypes.string
};

class ItemBlock extends PureComponent {
  constructor(props) {
    super(props);

    this.detectIE = this.detectIE.bind(this);
  }

  detectIE() {

    var oReturn = false;

    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

    if(isIE){
      oReturn = true;
    }
    else{
      oReturn = false;
    }


    return oReturn;




  }

  render() {
    const IEdetection = this.detectIE();
    const changePage = this.props.changePage;
    const { i18n: { messages } } = this.props;
    const blankImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAALuAQAAAAAV9gHgAAAACXBIWXMAAABIAAAASABGyWs+AAAAcklEQVR42u3BMQEAAADCoPVPbQlPoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgY3EzAAFPD7s3AAAANHRFWHRjb21tZW50ACBDUkVBVE9SOiBDSW1nIDogT3JpZ2luYWwgc2l6ZT0xMDAweDc1MHgxeDMKMNWJ6AAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wOC0yMVQwMzo0ODoyNC0wNTowMCV8EqUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDgtMjFUMDM6NDg6MjQtMDU6MDBUIaoZAAAAAElFTkSuQmCC";
    const block2 = this.props.dataInfo.map(function (article, i) {
      const isBlank = article.image.uri == "" ? blankImage : article.image.uri;
      const titleTrim = article.title.substring(70, 0) + "...";
      const descTrim = article.desc.substring(150, 0) + "...";
      const articleTitle = (IEdetection &&  article.title.length > 70) ? titleTrim : article.title;
      const articleDesc =  (IEdetection &&  article.desc.length > 150)  ? descTrim : article.desc;
      if (i != 0) {
        return (
          <div className="column display-item border-bottom-item small-12 medium-12 large-12">
            <a onClick={() => changePage({pathname: '/insights/article/' + article.articleId})}
               className="small-12 medium-12 large-12">
              <div className="small-4 medium-6 large-12 column no-margin no-padding">

                <div className="image-box" style={{
                  background: 'url(' + isBlank + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: "50% 50%"
                }}>
                  <img className="ghost" src={'../' + Settings.webfolder + '/images/apac/box.png'}/>
                </div>


              </div>
              <div className="small-8 medium-6 large-12 column no-margin item-info-box">
                <h4 className="article-title title-ellipsis">{articleTitle}</h4>
                <div className="article-date"><SimpleDate value={article.date} /></div>
                <div>
                  <p className="text item-text text-ellipsis">{articleDesc}</p>
                  <div className="text read-more" id="text_learnMore_itemBlock_test">{messages['app.insight.readMore']}</div>
                </div>
              </div>
            </a>
          </div>
        )
      }
    });

    return (
      <div className="row no-margin">
        <div className="small-up-1 medium-up-1 large-up-3">
          {block2}
        </div>
      </div>
    );
  }
}

ItemBlock.PropTypes = propTypes;

//export default ItemBlock;

export default createContainer({
  $queries: {
    changePage: {$call: 'ui.history.push'},
    i18n: {
      messages: true,
    },
  }
})(ItemBlock);
